import { gql } from '@apollo/client'

export const GET_ACTION_QUERY = gql`
  query ACTIONS($demandeId: bigint!) {
    actions: d4_action(where: { demande_id: { _eq: $demandeId } }, order_by: { datecreation: desc }) {
      id
      libelle
      datecreation
      daterealisation
      emetteur {
        id
        nom
        prenom
      }
      executeur {
        id
        nom
        prenom
      }
    }
  }
`
